import { AuthNavigation } from './AuthNavigation'

export default AuthNavigation
